// extracted by mini-css-extract-plugin
export var callCard = "_r1-0";
export var callMessageButton = "_r1-1";
export var helpIcon = "_r1-3";
export var helpIconContainer = "_r1-4";
export var verticalDivider = "_r1-2";